import React, { useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { CopyPartStatus } from '~/src/Project/store';

const CopyIssueWarning = ({ status }: { status: CopyPartStatus }) => {
  const [open, setOpen] = useState(true);
  const { t } = useTranslation('projects');

  const handleClose = () => setOpen(false);
  const isFailed = status === CopyPartStatus.Failed;

  return (
    <Collapse in={open}>
      <Box mb={6}>
        <Alert onClose={handleClose} severity={isFailed ? 'error' : 'warning'}>
          <Typography variant="body2">
            {t(isFailed ? 'copyProject.issue.failed' : 'copyProject.issue.partiallyCompleted')}
          </Typography>
        </Alert>
      </Box>
    </Collapse>
  );
};

export default React.memo(CopyIssueWarning);
